import React from 'react';
import {Badge} from './GenericBadges';
import styled from 'styled-components';
import {GenericIconName} from '../../../atoms/Icon/IconName';

const TEXT_MAXIMUM_CHARS = 31;

interface Props {
  imgIcon: {
    src: string;
    alt: string;
  };
  text: string;
  dataTestId: string;
  onClick?: VoidFunction;
}

export const SustainableBadge: React.FC<Props> = ({
  imgIcon,
  text,
  dataTestId,
  onClick,
}) => {
  // Ellipses text if it's too long
  const ellipsedText =
    text.substring(0, TEXT_MAXIMUM_CHARS) +
    (text.length > TEXT_MAXIMUM_CHARS ? '...' : '');

  const onClickHandler = (event: React.MouseEvent) => {
    if (!onClick) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    onClick();
  };

  const svgIcon: React.ComponentProps<typeof Badge>['svgIcon'] = {
    iconName: GenericIconName.InfoFilledGray,
    iconSize: 'XSS',
    showToTheRight: true,
  };

  return (
    <Wrapper onClick={onClickHandler}>
      <Badge
        dataTestId={dataTestId}
        imgIcon={imgIcon}
        text={ellipsedText}
        svgIcon={svgIcon}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  cursor: pointer;
`;
